import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import baptizeLogo from "../../assets/baptize-america-logo.png"; // Convert SVG to PNG or use base64
import CertificateOfBaptism from "../../assets/certificate-of-baptism.png";
import { CertificateFormData } from "./types";

const bibleVerses = {
  corinthians:
    "Therefore, if anyone is in Christ, he is a new creation. The old has passed away; behold, the new has come. — 2 Corinthians 5:17 (ESV)",
  colossians:
    "If then you have been raised with Christ, seek the things that are above, where Christ is, seated at the right hand of God. — Colossians 3:1 (ESV)",
  romans:
    "We were buried therefore with him by baptism into death, in order that, just as Christ was raised from the dead by the glory of the Father, we too might walk in newness of life. — Romans 6:4 (ESV)",
};

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: 40,
    alignItems: "center",
    justifyContent: "center",
  },
  certificateImage: {
    height: 70,
    marginBottom: 20,
  },
  logo: {
    height: 80,
    marginBottom: 20,
  },
  subtitle: {
    fontSize: 16,
    textTransform: "uppercase",
    marginBottom: 30,
    textAlign: "center",
    maxWidth: 800,
  },
  name: {
    fontSize: 32,
    fontWeight: "bold",
    marginTop: 20,
    marginBottom: 5,
  },
  hr: {
    width: 600,
    borderBottom: "1px solid black",
    marginBottom: 20,
  },
  verseText: {
    fontSize: 14,
    textAlign: "center",
    maxWidth: 600,
    marginTop: 40,
    textTransform: "uppercase",
  },
  verseRef: {
    fontSize: 12,
    marginTop: 10,
    fontWeight: "bold",
    marginBottom: 20,
  },
});

const BaptismCertificatePDF = ({ data }: { data: CertificateFormData }) => {
  const [verse, reference] = bibleVerses[data.designChoice].split(" — ");

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={styles.page}>
        <Image src={CertificateOfBaptism} style={styles.certificateImage} />
        <Text style={styles.subtitle}>
          ON THIS DATE, {data.baptismDate.toUpperCase()}, YOU CONFIRMED YOUR
          COMMITMENT TO{"\n"}JESUS CHRIST THROUGH WATER BAPTISM.
        </Text>
        <Text style={styles.name}>{data.name || "NAME"}</Text>
        <View style={styles.hr} />
        <Text style={styles.verseText}>{verse}</Text>
        <Text style={styles.verseRef}>{reference}</Text>
        <Image src={baptizeLogo} style={styles.logo} />
      </Page>
    </Document>
  );
};

export default BaptismCertificatePDF;
